const ApiPath = {
  Login: 'user/login',
  Logout: 'user/logout',
  Customer: 'customer',
  Product: 'product',
  Vehicle: 'vehicle',
  User: 'user',
  PosTerminal: 'pos-terminal',
  Transaction: 'transaction',
  FareMatrix: 'fare-matrix',
  GenerateReport: 'report',
  TransactionDashboard: 'transaction/dashboard',
  TransactionDashboard2: 'transaction/v2/dashboard',
  TransactionDashboard3: 'transaction/v3/dashboard',
  // Accounting
  Account: 'account',
  AccountCategory: 'account/category'
};

export default ApiPath;
